<div class="tr flex layout-row layout-align-start-center">

  <div class="td layout-row flex">
    <app-bringoz-state-link class="flex text-ellipsis"
                            [state]="'planning.project.project'"
                            [params]="{projectId: report.projectId}"
                            [text]="report.projectName">
    </app-bringoz-state-link>

  </div>

  <div class="td layout-row flex">

    <app-bringoz-state-link class="flex text-ellipsis"
                            [state]="'planning.template'"
                            [params]="{id: report.templateId}"
                            [text]="report.templateName">
    </app-bringoz-state-link>
  </div>

  <div class="td layout-row flex">
    <span class="report-status-group br-caption-2 layout-row layout-align-start-center"
          [ngbTooltip]="report.status ? projectReportStatusTooltip : null" container="body" openDelay="300"
          triggers="hover"
          [ngClass]="report.statusGroup">{{'PROJECT_GROUP_STATUS.' + report.statusGroup | translate}}
    </span>

    <ng-template #projectReportStatusTooltip>
      <div class="layout-column layout-align-start-start">
        <div class="br-body-2">{{'PROJECT_STATUS.' + report.status | translate}}</div>
        <div *ngIf="report.statusGroup === 'DONE'" class="layout-column">
          <div class="layout-row layout-align-start-center">
            <span class="br-body-2" translate>Total services</span>:
            <span class="margin-left-5">{{report.serviceProgress.total}}</span>
          </div>

          <div class="layout-row layout-align-start-center">
            <span class="br-body-2" translate>Dispatched services</span>:
            <span class="margin-left-5">{{report.serviceProgress.created}}</span>
          </div>

          <div class="layout-row layout-align-start-center">
            <span class="br-body-2" translate>Failed services</span>:
            <span class="margin-left-5">{{report.serviceProgress.failed}}</span>
          </div>

          <div class="layout-row layout-align-start-center">
            <span class="br-body-2" translate>Total routes</span>:
            <span class="margin-left-5">{{report.routeProgress.total}}</span>
          </div>

          <div class="layout-row layout-align-start-center">
            <span class="br-body-2" translate>Dispatched routes</span>:
            <span class="margin-left-5">{{report.routeProgress.created}}</span>
          </div>

          <div class="layout-row layout-align-start-center">
            <span class="br-body-2" translate>Failed routes</span>:
            <span class="margin-left-5">{{report.routeProgress.failed}}</span>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="td layout-row flex">
     <span *ngIf="!!report.from" class="br-caption-1 gray-103 font-weight-400">
      {{ report | bringozDate: 'from'}}  {{ report  | bringozTime: 'from'}}
     </span>
  </div>

  <div class="td layout-row flex">
    <span *ngIf="!!report.to" class="br-caption-1 gray-103 font-weight-400">
      {{ report | bringozDate: 'to'}}  {{ report  | bringozTime: 'to'}}
     </span>
  </div>


</div>
